import { Pipe, PipeTransform } from '@angular/core';
import { DictionaryItem } from '../../../domain/dictionary.model';

@Pipe({
    name: 'joinDescriptions'
})
export class JoinDescriptionsPipe implements PipeTransform {
    transform(list: DictionaryItem[], separator: string = ', '): string {
        return list.map(i => i.description).join(separator);
    }
}
